import { FC } from "react";
import { Grid, Typography } from "@mui/material";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { useTranslation } from "react-i18next";
import { SCUIButton } from "../../../../../atomic/atoms";
import { useHistory } from "react-router-dom";
import { StoreQuery } from "../../../../../services/query";
import Swal from "sweetalert2";

export const RefundPrepareSellerReturnShipment: FC<{
  orderId?: number;
  customerId?: any;
  irsaliyeFaturaSeriNo?: any;
  shippingListId?: any;
  returnId?: any;
}> = ({
  orderId,
  customerId,
  irsaliyeFaturaSeriNo,
  shippingListId,
  returnId,
}) => {
  const { t } = useTranslation();
  const buttonText = irsaliyeFaturaSeriNo
    ? "İrsaliye & Fatura Seri/No " + irsaliyeFaturaSeriNo
    : "Fatura ve İrsaliye Oluştur";

  const fatura = async () => {
    let params = {
      documentNo: irsaliyeFaturaSeriNo,
      referenceId: shippingListId,
      customerId: customerId,
      orderId: orderId,
      returnId: returnId,
      IsMpReturnDispatch: true,
    };
    StoreQuery.GetStoreDispatchFileForReturn(params).catch((error: any) => {
      switch (error.status) {
        case 401:
          Swal.fire(t("general.sessionExpiredError"), "", "error");
          break;
        case 403:
          Swal.fire(t("general.authorizationError"), "", "error");
          break;
        case 404:
          Swal.fire({
            text: "İrsaliye hazırlanıyor",
            icon: "info",
            timer: 5000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          setTimeout(function () {
            fatura();
          }, 5000);
          break;
        case 500:
          Swal.fire(t("general.serviceError"), "", "error");
          break;
        case 400:
          Swal.fire({
            icon: "error",
            title: error.data,
            showConfirmButton: false,
            timer: 1500,
          });
      }
    });
  };
  const label = () => {
    let params = { shippingListId: shippingListId, returnId: returnId };
    StoreQuery.GetMPReturnCargoLabel(params);
  };
  const history = useHistory();

  return (
    <Grid
      container
      sx={{ padding: "2rem", marginTop: 1 }}
      spacing={5}
      rowSpacing={20}
    >
      <Grid
        size={{
          md: 6,
          xs: 12,
          lg: 4
        }}>
        <SCUIButton
          type="primary"
          sizeType="fixed"
          text="Kargo Etiketi"
          showStartIcon
          startIcon={<LocalPrintshopIcon style={{ color: "white" }} />}
          size="m"
          fullwidth
          onClick={() => {
            label();
          }}
        ></SCUIButton>
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12,
          lg: 4
        }}>
        <SCUIButton
          type="primary"
          sizeType="fixed"
          text={buttonText}
          showStartIcon
          startIcon={<LocalPrintshopIcon style={{ color: "white" }} />}
          size="m"
          onClick={() => {
            fatura();
          }}
          fullwidth
        ></SCUIButton>
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12,
          lg: 4
        }}>
        <SCUIButton
          text={"Sevk İşlemleri"}
          type="primary"
          sizeType="fixed"
          size={"m"}
          onClick={() => {
            history.push("/MPPrepareReturnToSellerList");
          }}
          fullwidth
        />
      </Grid>
      <Grid
        size={{
          md: 12,
          xs: 12,
          lg: 12
        }}>
        <br />
        <Typography variant="caption" display="block" gutterBottom color="red">
          <b>İrsaliye yazdırmak için ilgili butona tıklayın!</b>
        </Typography>

        <Typography variant="caption" display="block" gutterBottom color="red">
          <b>Kargo etiketi yazdırmak için ilgili butona tıklayın </b>
        </Typography>

        <Typography variant="caption" display="block" gutterBottom color="red">
          <b>
            Tüm Marketplace sevk işlemleri için “Sevk İşlemleri” butonuna
            tıklayın{" "}
          </b>
        </Typography>
      </Grid>
    </Grid>
  );
};
